import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/utils'

export type RequestSummaryItem = {
  label: string
  value: string
}

export function RequestSummaryPanel({
  title,
  items,
  action,
  className,
}: {
  title: string
  items: RequestSummaryItem[]
  action?: ReactNode
  className?: string
}) {
  return (
    <aside className={cn('rounded-lg border border-border bg-card p-4 shadow-sm', className)} aria-label={title}>
      <h2 className="font-display text-base font-semibold text-foreground">{title}</h2>
      <dl className="mt-4 space-y-3">
        {items.map((item) => (
          <div key={item.label} className="flex items-start justify-between gap-4 text-sm">
            <dt className="text-muted-foreground">{item.label}</dt>
            <dd className="text-right font-medium text-foreground">{item.value}</dd>
          </div>
        ))}
      </dl>
      {action ? <div className="mt-4">{action}</div> : null}
    </aside>
  )
}
